import React, { useState } from "react";
import { toast } from "react-toastify";

const options = {
  autoClose: 5000,
  hideProgressBar: false,
  position: toast.POSITION.TOP_RIGHT,
  pauseOnHover: true,
};

const CopyableToastMessage = ({ message }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      if (navigator?.clipboard?.writeText) {
        await navigator.clipboard.writeText(message);
      }
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (error) {
      setCopied(false);
      console.error("Failed to copy toast message:", error);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8, minWidth: 0 }}>
      <div
        style={{
          maxHeight: 160,
          overflowY: "auto",
          wordBreak: "break-word",
          whiteSpace: "pre-wrap",
        }}
      >
        {message}
      </div>
      <button
        type="button"
        onClick={handleCopy}
        style={{
          alignSelf: "flex-end",
          flexShrink: 0,
          border: "1px solid rgba(255,255,255,0.35)",
          borderRadius: 4,
          background: "transparent",
          color: "inherit",
          cursor: "pointer",
          fontSize: 12,
          padding: "2px 8px",
          lineHeight: 1.4,
          whiteSpace: "nowrap",
        }}
      >
        {copied ? "Copied" : "Copy"}
      </button>
    </div>
  );
};

const myToast = {
  success: (message) => {
    toast.success(message, options);
  },
  info: (message) => {
    toast.info(message, options);
  },
  error: (message, config = {}) => {
    const toastConfig = {
      ...options,
      ...(config?.copy ? { autoClose: false, closeOnClick: false } : {}),
      ...(config?.toastId ? { toastId: config.toastId } : {}),
    };

    if (config?.copy) {
      toast.error(<CopyableToastMessage message={message} />, toastConfig);
      return;
    }
    toast.error(message, toastConfig);
  },
  warning: (message) => {
    toast.warn(message, options);
  },
};

export default myToast;
